<template>
  <b-container fluid class="mt-1 mb-5">
    <b-overlay :show="isSubmitting">
      <template v-slot:overlay>
        <div class="text-center">
          <b-icon-stopwatch font-scale="3" animation="cylon"></b-icon-stopwatch>
          <p id="cancel-label">Saving, please wait...</p>
        </div>
      </template>

      <b-row class="mb-2">
        <b-col>
          <b-button variant="blue" @click="onClose" v-if="allowReturn">
            <b-icon-building />
            Return to Accounts
          </b-button>
          <b-button variant="orange" @click="onClose" v-else>
            <b-icon-arrow-left />
            Return to Account
          </b-button>
        </b-col>
        <b-col v-if="site.id">
          <div class="d-flex justify-content-end">
            <b-button @click="showSiteEdit = !showSiteEdit" variant="blue">
              <b-icon-Pencil />
              <span v-if="!showSiteEdit">Edit Site Details</span>
              <span v-else>Done</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="!site.id || site.id === 0 || showSiteEdit">
        <b-col>
          <b-form
            :class="{
              'needs-validation': !submitted,
              'was-validated': submitted
            }"
            novalidate
          >
            <h5>Site Details</h5>
            <b-container>
              <b-form-group
                label="Site Name:"
                :label-cols="2"
                label-align="right"
                :invalid-feedback="validationStat.siteName.msg"
              >
                <b-input
                  v-model="site.name"
                  @blur="onBlur"
                  required
                  :state="validationStat.siteName.state"
                  ref="siteName"
                  id="siteName"
                  :maxlength="255"
                />
              </b-form-group>

              <b-row>
                <b-col>
                  <b-form-group
                    label="Address:"
                    :label-cols="2"
                    label-align="right"
                    :invalid-feedback="validationStat.address.msg"
                  >
                    <b-input
                      v-model="site.address"
                      @blur="onBlur"
                      required
                      :state="validationStat.address.state"
                      ref="address"
                      id="address"
                      :maxlength="255"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="justify-content-start" :md="6">
                  <b-form-group
                    label="City:"
                    :label-cols="4"
                    label-align="right"
                    :invalid-feedback="validationStat.city.msg"
                  >
                    <b-input
                      v-model="site.city"
                      @blur="onBlur"
                      required
                      :state="validationStat.city.state"
                      ref="city"
                      id="city"
                      :maxlength="255"
                    />
                  </b-form-group>
                </b-col>
                <b-col :md="3">
                  <b-form-group
                    label="State:"
                    :label-cols="7"
                    label-align="right"
                    :invalid-feedback="validationStat.state.msg"
                  >
                    <b-input
                      v-model="site.state"
                      @blur="onBlur"
                      required
                      :state="validationStat.state.state"
                      ref="state"
                      id="state"
                      :maxlength="2"
                    />
                  </b-form-group>
                </b-col>
                <b-col :md="3">
                  <b-form-group
                    label="Zip:"
                    :label-cols="5"
                    label-align="right"
                    :invalid-feedback="validationStat.zip.msg"
                  >
                    <b-input
                      v-model="site.postal_code"
                      @blur="onBlur"
                      required
                      :state="validationStat.zip.state"
                      ref="zip"
                      id="zip"
                      :maxlength="5"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-form>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <span class="display-title" v-if="true">
            {{ site.name }} location
          </span>
          <span class="display-title" v-else>
            {{ account.name }}/{{ site.name }}
          </span>
        </b-col>
      </b-row>
      <hr />
      <b-row v-if="!showSiteEdit && site.id">
        <b-col>
          <h5>
            Open Orders
          </h5>
          <dx-data-grid
            :data-source="site.orders"
            :columns="gridOrders.columns"
            style="max-height:450px!important;"
          ></dx-data-grid>
        </b-col>
      </b-row>
      <hr v-if="!showSiteEdit && site.id" />
      <b-row>
        <b-col>
          <h5>Equipment Manifest</h5>
          <b-container fluid class="d-flex justify-content-end ml-3">
            <b-row>
              <b-col class="d-flex justify-content-end">
                <b-button @click="onAddEquipment" variant="blue">
                  <b-icon-plus />
                </b-button>
              </b-col>
            </b-row>
          </b-container>
          <dx-data-grid
            :data-source="site.devices"
            :columns="gridEquipment.columns"
            :editing="gridEquipment.editing"
            :onRowRemoving="onRemovingItem"
            style="max-height:450px!important;"
            ref="devGrid"
          ></dx-data-grid>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <h5>Frequently-Ordered Items</h5>
          <dx-data-grid
            :data-source="site.favorite_Items"
            :columns="gridFavorites.columns"
            :editing="gridFavorites.editing"
            :onRowRemoving="onRemovingItem"
            style="max-height:450px!important;"
            ref="fav"
          >
          </dx-data-grid>
          <b-input-group class="mt-4">
            <b-select
              :options="options"
              v-model="favoriteSelection"
              :disabled="!options"
            >
            </b-select>
            <template #append>
              <b-button
                variant="blue"
                @click="onAddFavoriteClick"
                :disabled="!favoriteSelection"
              >
                <span class="h6">
                  <b-icon-plus />
                </span>
              </b-button>
            </template>
          </b-input-group>
        </b-col>
      </b-row>
      <hr />
      <b-row v-if="!showSiteEdit && site.id">
        <b-col>
          <h5 v-if="!showSiteEdit">{{ site.name }} Users</h5>
          <b-container
            class="d-flex justify-content-end m-3"
            v-if="!showSiteEdit"
          >
            <b-row v-if="false">
              <b-col class="d-flex justify-content-end">
                <b-button @click="onAddUserClick" variant="blue">
                  <b-icon-plus />
                </b-button>
              </b-col>
            </b-row>
          </b-container>
          <dx-data-grid
            :data-source="site.users"
            :columns="gridUsers.columns"
            style="max-height:450px!important;"
            v-if="!showSiteEdit"
          >
          </dx-data-grid>
        </b-col>
      </b-row>
      <hr v-if="!showSiteEdit && site.id" />
      <b-row>
        <b-col>
          <h5>LINK Notifications</h5>
          <dx-data-grid
            :data-source="site.site_memberships"
            :columns="gridMembers.columns"
            :editing="gridMembers.editing"
            :onRowRemoving="onRemovingItem"
            style="max-height:450px!important;"
          >
          </dx-data-grid>
          <b-input-group class="mt-3">
            <b-select :options="sa" v-model="memberSelection" />
            <template #append>
              <b-button
                variant="blue"
                @click="onMemberAddClick"
                :disabled="!memberSelection"
              >
                <span class="h6">
                  <b-icon-plus />
                </span>
              </b-button>
            </template>
          </b-input-group>
        </b-col>
      </b-row>
      <hr />
      <user-edit
        :display="showUserEditor"
        @onUserEditorStatChanged="getUeStat"
        v-if="site"
      />
      <equipment-editor
        :display="showDeviceEditor"
        @onStatChange="getDeStat"
        v-if="site"
      />
      <b-row v-if="allowReturn">
        <b-col class="d-flex justify-content-start">
          <b-button variant="blue" @click="onSubmit">Save</b-button>
        </b-col>
        <b-col class="d-flex justify-content-end">
          <b-button variant="orange" @click="onClose">Cancel</b-button>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>
import { confirm } from "devextreme/ui/dialog";
import notify from "devextreme/ui/notify";

import UserEdit from "./UserEdit";
import EquipmentEditor from "./EquipmentEdit";

export default {
  props: ["to", "allowReturn"],
  components: {
    UserEdit,
    EquipmentEditor
  },
  data() {
    return {
      favoriteSelection: null,
      memberSelection: null,
      submitted: false,
      isSubmitting: false,
      validationStat: {
        siteName: {
          msg: "",
          state: null
        },
        address: {
          msg: "",
          state: null
        },
        city: {
          msg: "",
          state: null
        },
        state: {
          msg: "",
          state: null
        },
        zip: {
          msg: "",
          state: null
        }
      },
      gridOrders: {
        columns: [
          {
            dataField: "number",
            caption: "Order #",
            alignment: "start"
          },
          {
            dataField: "status",
            alignment: "center",
            width: 175
          },
          {
            dataField: "placed",
            caption: "Last Activity",
            width: 250
          }
        ]
      },
      gridEquipment: {
        columns: [
          {
            dataField: "name",
            caption: "Model"
          },
          // {
          //   dataFields: "device_models_id",
          //   caption: "Model",
          //   calculateDisplayValue: this.displayEquipment
          // },
          {
            dataField: "asset_tag",
            width: 200
          }
        ],
        editing: {
          allowDeleting: true,
          useIcons: true
        }
      },
      gridFavorites: {
        columns: [
          {
            dataField: "name",
            caption: "Item Description",
            alignment: "left"
            // calculateDisplayValue: this.displayFavorite
          }
        ],
        editing: {
          allowDeleting: true,
          useIcons: true
        }
      },
      gridUsers: {
        columns: [
          {
            caption: "Name",
            calculateDisplayValue: this.userGivenNameDisplay
          },
          {
            dataField: "email"
          }
        ]
      },
      gridMembers: {
        columns: [
          {
            caption:
              "When activity occurs for this site, notify the following LINK Document Services Group Staff.",
            dataField: "name"
          }
        ],
        editing: {
          allowDeleting: true,
          useIcons: true
        }
      },
      showSiteEdit: false, //flags to display site details (e.g. name, address, etc.) for editing
      showUserEditor: false,
      showDeviceEditor: false
    };
  },
  beforeMount() {
    debugger;

    if (this.site) {
      if (this.site.orders) {
        //Force open orders only:
        this.site.orders = this.site.orders.filter(
          o => o.status !== "Delivered"
        );
      }
    }
  },
  mounted() {
    this.$refs.devGrid.$_instance.repaint();
    this.$refs.fav.$_instance.repaint();
  },
  computed: {
    site: {
      get() {
        var site = this.$store.getters["accounts/currentSite"];
        if (site) {
          debugger;
          return site;
        } else {
          return {};
        }
      },
      set(val) {
        return this.$store.dispatch("accounts/currentSite", null);
      }
    },
    account() {
      return this.$store.getters["accounts/currentAccount"];
    },
    selectedAccount: {
      get() {
        return this.$store.getters["accounts/currentAccount"];
      },
      set(val) {
        this.$store.dispatch("accounts/currentAccount", val);
      }
    },
    models() {
      if (!this.$store) {
        return [];
      }
      debugger;
      var mods = this.$store.getters["sysEquipment/models"]
        ? this.$store.getters["sysEquipment/models"]
        : [];
      return mods;
    },
    items() {
      if (!this.$store) {
        return [];
      }
      var itms = this.$store.getters["sysItems/items"]
        ? this.$store.getters["sysItems/items"]
        : [];
      return itms;
    },
    categories() {
      return this.$store.getters["sysItems/categories"];
    },
    options() {
      var opts = [
        {
          value: null,
          text: "Please select an item.",
          disabled: true
        }
      ];

      this.categories.forEach(cat => {
        var relatedItems = this.items.filter(
          itm => itm.item_category_id === cat.id
        );

        var collection = {
          label: cat.name,
          options: []
        };

        relatedItems.forEach(itm => {
          collection.options.push({
            value: itm.id,
            text: itm.name
          });
        });

        opts.push(collection);
      });

      return opts;
    },
    sa() {
      var saUsers = this.$store.getters["accounts/saUsers"];
      var saResponse = [
        {
          value: null,
          text: "Choose a person",
          disabled: true
        }
      ];

      saUsers.forEach(u => {
        saResponse.push({
          value: u.user_id,
          text: u.name
        });
      });

      return saResponse;
    },
    wasModified: {
      get() {
        return this.$store.getters["accounts/isDirty"];
      },
      set(val) {
        return this.$store.dispatch("accounts/flagChanges", val);
      }
    }
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      debugger;
      this.isSubmitting = true;

      var site = this.$store.getters["accounts/currentSite"];

      debugger;

      if (site) {
        //is this a new site?
        if (site.favorite_Items) {
          var deletedItems = site.favorite_Items.filter(i => i.delete && !i.id);
          if (deletedItems.length > 0) {
            deletedItems.forEach(i => delete site.favorite_Items[i]);
          }
        }

        if (!site.id) {
          this.selectedAccount.sites.push(site); // add to list then submit update.
        }
      }

      if (!this.selectedAccount.id) {
        return this.$store.dispatch("accounts/addAccount").then(rsp => {
          if (rsp) {
            // this.$router.push({ name: "accounts" });
            this.reset();
          }
        });
      } else {
        return this.$store.dispatch("accounts/updateAccount").then(rsp => {
          this.reset();
          //   if (rsp) {
          //     this.selectedAccount = null;
          //     this.$router.push({ name: "accounts" });
          //   }
        });
      }
    },
    onClose() {
      // this.site = null;
      if (this.allowReturn) {
        this.reset();
        // return (
        //   this.$store
        //     .dispatch("accounts/getAccounts")
        //     // .then(() => this.$router.push("/admin/accounts"))
        //     .then(() => (this.showSiteEditor = false))
        //     .then(() => (this.wasModified = false))
        //     .then(() => (this.selectedAccount = null))
        //     .then(() => (this.site = null))
        //     .then(() => (window.location = "#/admin/accounts"))
        // );
      } else {
        this.$emit("onClose", false);
        // return (
        //   this.$store
        //     .dispatch("accounts/getAccounts")
        //     // .then(() => this.$router.push("/admin/accounts"))
        //     .then(() => (this.showSiteEditor = false))
        //     .then(() => (this.wasModified = false))
        //     .then(() => (this.selectedAccount = null))
        //     .then(() => (this.site = null))
        //     .then(() => this.$emit("onClose", false))
        // );
      }
    },
    reset() {
      return (
        this.$store
          .dispatch("accounts/getAccounts")
          // .then(() => this.$router.push("/admin/accounts"))
          .then(() => (this.showSiteEditor = false))
          .then(() => (this.wasModified = false))
          .then(() => (this.selectedAccount = null))
          .then(() => (this.isSubmitting = false))
          .then(() => (window.location = "#/admin/accounts"))
      );
    },
    displayEquipment(e) {
      debugger;
      var model = this.models.find(m => m.id === e.device_model_id);

      if (!model) {
        return "";
      }

      return model.model;
    },
    displayFavorite(e) {
      var item = this.items.find(itm => itm.id === e.item_id);
      if (!item) {
        return "";
      }
      return item.name;
    },
    userGivenNameDisplay(e) {
      return e.first_name + " " + e.last_name;
    },
    onRemovingDevice(e) {
      debugger;
      var rsl = this.$store.dispatch("accounts/removeDevice", e.data.id);
      rsl.then(rsp => {
        debugger;
        if (!rsp) {
          e.cancel = true;
          return;
        }

        return;
      });
    },
    onAddEquipment() {
      this.showDeviceEditor = true;
    },
    onFavoriteRemove(e) {
      // debugger;
      e.data.delete = true;
      this.wasModified = true;

      e.cancel = true;

      var rowIndex = e.component.getRowIndexByKey(e.key);

      var $commandEditCell = e.component.getCellElement(
        rowIndex,
        "command:edit"
      );

      $commandEditCell.hidden = true;
      return;
    },
    onRemovingItem(e) {
      debugger;

      e.data.delete = true;

      this.wasModified = true;

      e.cancel = true;

      var rowIndex = e.component.getRowIndexByKey(e.key);

      var $commandEditCell = e.component.getCellElement(
        rowIndex,
        "command:edit"
      );

      $commandEditCell.hidden = true;
      return;
    },
    onAddFavoriteClick(e) {
      debugger;
      var item = this.site.favorite_Items.find(
        itm => itm.item_id === this.favoriteSelection
      );

      if (item) {
        notify(
          "Item is already part of the Frequently ordered items.",
          "error",
          4000
        );
        this.favoriteSelection = null;
        return;
      }

      this.site.favorite_Items.push({
        item_id: this.favoriteSelection,
        name: this.items.find(i => i.id === this.favoriteSelection).name
      });

      this.favoriteSelection = null;
    },
    onAddUserClick(e) {
      this.showUserEditor = true;
    },
    onMemberAddClick(e) {
      debugger;
      var user = this.site.site_memberships.find(
        usr => usr.user_id === this.memberSelection
      );

      if (user) {
        notify(
          user.name + " is already on the LINK Notifications list.",
          "error",
          4000
        );
        return;
      }
      debugger;
      var saUsers = this.$store.getters["accounts/saUsers"];
      var member = saUsers.find(m => m.user_id === this.memberSelection);
      this.site.site_memberships.push(member);
      this.memberSelection = null;
    },
    getUeStat(e) {
      debugger;
      this.showUserEditor = e;
    },
    getDeStat(e) {
      this.showDeviceEditor = e;
    },
    onBlur(e) {
      debugger;
      var isStr = typeof e.target.value === "string";

      if (isStr) {
        e.target.value = e.target.value.trim();
        this.validationStat[e.target.id].msg = e.target.validationMessage;
        this.validationStat[e.target.id].state = e.target.checkValidity();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/SiteEdit.vue